import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getTimeline = (id: any, apiParam: string): Promise<any> =>
  apiClient(`/v1/timeline/${getOrgId()}/${apiParam}/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
